import React from 'react'
import GetAppIcon from '@material-ui/icons/GetApp'
import { CSVLink } from 'react-csv'
import { Box, Table, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { Grid } from '@material-ui/core'

function TableWithDownload(props) {
  return (
    <Box>
      <Grid container spacing={3} style={{ marginBottom: '1rem' }}>
        <Grid item xs={6} align='left'>
          <h5>{props.title}</h5>
        </Grid>
        <Grid item xs={6} align='right'>
          {props.download && props.data.length > 0 && (
            <CSVLink
              data={props.data}
              filename={props.downloadFileName + '.csv'}
              className='btn btn-primary'
              target='_blank'
            >
              {' '}
              <GetAppIcon /> CSV
            </CSVLink>
          )}
        </Grid>
      </Grid>
      {props.loading ? (
        <Box>Loading...</Box>
      ) : !props.data || !props.data.length ? (
        <Box>There are no records to display.</Box>
      ) : (
        <>
          <TableContainer>
            <Table className='table' id='table-css'>
              <TableHead style={{ heigth: '4rem' }}>
                <TableRow style={{ heigth: '4rem' }}>
                  {props.columns.map((each, ind) => {
                    return <th style={each.style}>{each.name}</th>
                  })}
                </TableRow>
              </TableHead>

              <TableHead>
                {props.data.map((each, indx) => {
                  return (
                    <TableRow key={indx}>
                      {props.columns.map((one, ind) => {
                        return <TableCell>{each[one.selector]}</TableCell>
                      })}
                    </TableRow>
                  )
                })}
              </TableHead>
            </Table>
          </TableContainer>
        </>
      )}
    </Box>
  )
}

export default TableWithDownload
